import { UPDATE_PROPERTIES_APPLIED_FILTER } from "../../constants/propertiesConstants";

export function updateAppliedFilter(values) {
  return {
    type: UPDATE_PROPERTIES_APPLIED_FILTER,
    payload: values
  }
}